import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { collisionVelocity, getDistances, getValue } from "./NumberUtils";
import { Vector } from "../Core";

function rectSideBounce(pSide, pOtherSide, rectSide, rectOtherSide, velocity, factor) {
  var res = {
    bounced: false
  };

  if (pOtherSide.min >= rectOtherSide.min && pOtherSide.min <= rectOtherSide.max && pOtherSide.max >= rectOtherSide.min && pOtherSide.max <= rectOtherSide.max) {
    if (pSide.max >= rectSide.min && pSide.max <= (rectSide.max + rectSide.min) / 2 && velocity > 0 || pSide.min <= rectSide.max && pSide.min > (rectSide.max + rectSide.min) / 2 && velocity < 0) {
      res.velocity = velocity * -factor;
      res.bounced = true;
    }
  }

  return res;
}

function checkSelector(element, selectors) {
  if (selectors instanceof Array) {
    var _iterator = _createForOfIteratorHelper(selectors),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var selector = _step.value;

        if (element.matches(selector)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  } else {
    return element.matches(selectors);
  }
}

export function isSsr() {
  return typeof window === "undefined" || !window || typeof window.document === "undefined" || !window.document;
}
export function animate() {
  return isSsr() ? function (callback) {
    return setTimeout(callback);
  } : function (callback) {
    return (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || window.setTimeout)(callback);
  };
}
export function cancelAnimation() {
  return isSsr() ? function (handle) {
    return clearTimeout(handle);
  } : function (handle) {
    return (window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || window.clearTimeout)(handle);
  };
}
export function isInArray(value, array) {
  return value === array || array instanceof Array && array.indexOf(value) > -1;
}
export function loadFont(_x) {
  return _loadFont.apply(this, arguments);
}

function _loadFont() {
  _loadFont = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(character) {
    var _a, _b;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return document.fonts.load("".concat((_a = character.weight) !== null && _a !== void 0 ? _a : "400", " 36px '").concat((_b = character.font) !== null && _b !== void 0 ? _b : "Verdana", "'"));

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _loadFont.apply(this, arguments);
}

export function arrayRandomIndex(array) {
  return Math.floor(Math.random() * array.length);
}
export function itemFromArray(array, index) {
  var useIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var fixedIndex = index !== undefined && useIndex ? index % array.length : arrayRandomIndex(array);
  return array[fixedIndex];
}
export function isPointInside(point, size, radius, direction) {
  return areBoundsInside(calculateBounds(point, radius !== null && radius !== void 0 ? radius : 0), size, direction);
}
export function areBoundsInside(bounds, size, direction) {
  var inside = true;

  if (!direction || direction === "bottom") {
    inside = bounds.top < size.height;
  }

  if (inside && (!direction || direction === "left")) {
    inside = bounds.right > 0;
  }

  if (inside && (!direction || direction === "right")) {
    inside = bounds.left < size.width;
  }

  if (inside && (!direction || direction === "top")) {
    inside = bounds.bottom > 0;
  }

  return inside;
}
export function calculateBounds(point, radius) {
  return {
    bottom: point.y + radius,
    left: point.x - radius,
    right: point.x + radius,
    top: point.y - radius
  };
}
export function deepExtend(destination) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];

    if (source === undefined || source === null) {
      continue;
    }

    if (typeof source !== "object") {
      destination = source;
      continue;
    }

    var sourceIsArray = Array.isArray(source);

    if (sourceIsArray && (typeof destination !== "object" || !destination || !Array.isArray(destination))) {
      destination = [];
    } else if (!sourceIsArray && (typeof destination !== "object" || !destination || Array.isArray(destination))) {
      destination = {};
    }

    var _loop = function _loop(key) {
      if (key === "__proto__") {
        return "continue";
      }

      var sourceDict = source;
      var value = sourceDict[key];
      var isObject = typeof value === "object";
      var destDict = destination;
      destDict[key] = isObject && Array.isArray(value) ? value.map(function (v) {
        return deepExtend(destDict[key], v);
      }) : deepExtend(destDict[key], value);
    };

    for (var key in source) {
      var _ret = _loop(key);

      if (_ret === "continue") continue;
    }
  }

  return destination;
}
export function isDivModeEnabled(mode, divs) {
  return divs instanceof Array ? !!divs.find(function (t) {
    return t.enable && isInArray(mode, t.mode);
  }) : isInArray(mode, divs.mode);
}
export function divModeExecute(mode, divs, callback) {
  if (divs instanceof Array) {
    var _iterator2 = _createForOfIteratorHelper(divs),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var div = _step2.value;
        var _divMode = div.mode;
        var divEnabled = div.enable;

        if (divEnabled && isInArray(mode, _divMode)) {
          singleDivModeExecute(div, callback);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } else {
    var _divMode2 = divs.mode;
    var _divEnabled = divs.enable;

    if (_divEnabled && isInArray(mode, _divMode2)) {
      singleDivModeExecute(divs, callback);
    }
  }
}
export function singleDivModeExecute(div, callback) {
  var selectors = div.selectors;

  if (selectors instanceof Array) {
    var _iterator3 = _createForOfIteratorHelper(selectors),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var selector = _step3.value;
        callback(selector, div);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  } else {
    callback(selectors, div);
  }
}
export function divMode(divs, element) {
  if (!element || !divs) {
    return;
  }

  if (divs instanceof Array) {
    return divs.find(function (d) {
      return checkSelector(element, d.selectors);
    });
  } else if (checkSelector(element, divs.selectors)) {
    return divs;
  }
}
export function circleBounceDataFromParticle(p) {
  return {
    position: p.getPosition(),
    radius: p.getRadius(),
    mass: p.getMass(),
    velocity: p.velocity,
    factor: Vector.create(getValue(p.options.bounce.horizontal), getValue(p.options.bounce.vertical))
  };
}
export function circleBounce(p1, p2) {
  var _p1$velocity$sub = p1.velocity.sub(p2.velocity),
      xVelocityDiff = _p1$velocity$sub.x,
      yVelocityDiff = _p1$velocity$sub.y;

  var _ref = [p1.position, p2.position],
      pos1 = _ref[0],
      pos2 = _ref[1];

  var _getDistances = getDistances(pos2, pos1),
      xDist = _getDistances.dx,
      yDist = _getDistances.dy;

  if (xVelocityDiff * xDist + yVelocityDiff * yDist >= 0) {
    var angle = -Math.atan2(yDist, xDist);
    var m1 = p1.mass;
    var m2 = p2.mass;
    var u1 = p1.velocity.rotate(angle);
    var u2 = p2.velocity.rotate(angle);
    var v1 = collisionVelocity(u1, u2, m1, m2);
    var v2 = collisionVelocity(u2, u1, m1, m2);
    var vFinal1 = v1.rotate(-angle);
    var vFinal2 = v2.rotate(-angle);
    p1.velocity.x = vFinal1.x * p1.factor.x;
    p1.velocity.y = vFinal1.y * p1.factor.y;
    p2.velocity.x = vFinal2.x * p2.factor.x;
    p2.velocity.y = vFinal2.y * p2.factor.y;
  }
}
export function rectBounce(particle, divBounds) {
  var pPos = particle.getPosition();
  var size = particle.getRadius();
  var bounds = calculateBounds(pPos, size);
  var resH = rectSideBounce({
    min: bounds.left,
    max: bounds.right
  }, {
    min: bounds.top,
    max: bounds.bottom
  }, {
    min: divBounds.left,
    max: divBounds.right
  }, {
    min: divBounds.top,
    max: divBounds.bottom
  }, particle.velocity.x, getValue(particle.options.bounce.horizontal));

  if (resH.bounced) {
    if (resH.velocity !== undefined) {
      particle.velocity.x = resH.velocity;
    }

    if (resH.position !== undefined) {
      particle.position.x = resH.position;
    }
  }

  var resV = rectSideBounce({
    min: bounds.top,
    max: bounds.bottom
  }, {
    min: bounds.left,
    max: bounds.right
  }, {
    min: divBounds.top,
    max: divBounds.bottom
  }, {
    min: divBounds.left,
    max: divBounds.right
  }, particle.velocity.y, getValue(particle.options.bounce.vertical));

  if (resV.bounced) {
    if (resV.velocity !== undefined) {
      particle.velocity.y = resV.velocity;
    }

    if (resV.position !== undefined) {
      particle.position.y = resV.position;
    }
  }
}